import React from 'react';
import ChevronLeftIcon from '@/assets/icons/chevron-left.svg';
import { useNavigate } from 'react-router-dom';

interface MultiStepHeaderProps {
  currentStep: number;
  totalSteps: number;
  title: string;
  description: string;
}

const MultiStepHeader: React.FC<MultiStepHeaderProps> = ({ currentStep, totalSteps, title, description }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="w-full hidden md:block">
      <div className="w-full flex justify-between items-start gap-2 mb-2">
        {Array.from({ length: totalSteps }, (_, index) => (
          <span
            key={index}
            className={`flex-1 h-[4px] rounded-[2px] ${index < currentStep ? 'bg-primary' : 'bg-lightGray'}`}
          ></span>
        ))}
      </div>

      <p className="uppercase font-bold text-[28px] flex items-center gap-2">
        {currentStep > 1 && (
          <button className="w-8 h-8" onClick={handleBack}>
            {' '}
            <img src={ChevronLeftIcon} alt="chevron-left" className="w-5 h-5" />
          </button>
        )}
        <span>{title}</span>
      </p>
      <p className="text-secondary text-lg leading-[22px] mt-1">{description}</p>
    </div>
  );
};

export default MultiStepHeader;
